import { render, staticRenderFns } from "./editButtonTemplate5.vue?vue&type=template&id=080f2abe"
import script from "./editButtonTemplate5.vue?vue&type=script&lang=js"
export * from "./editButtonTemplate5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports